<template>
  <input-widget :label="label" :model="model" :attribute="attribute" append="%" :hint="hint" type="number" :step="step"
                :disabled="disabled" :rules="rules" @input="onInput"/>
</template>

<script>
  import InputWidget from "./../components/input-widget/InputWidget";

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "PercentageInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: 'min_value:0|max_value:100',
        required: false
      },
      step: {
        type: [String, Number],
        default: 0.1,
        required: false
      },
    },
    methods: {
      onInput($event) {
        this.$emit('input', $event);
      },
    },
  }
</script>

<style scoped>
</style>
